import { configureStore } from "@reduxjs/toolkit";
import modalReducer from './modalSlice';
import voteReducer from './vote/voteSlice'

export const store = configureStore({
  reducer: {
    modals: modalReducer,
    voteFlow: voteReducer,
  }
});